<script>
import Popin from "@/containers/popin-adaptive";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import LinkTo from "@/components/atoms/link-to";
import dateUtils from "@/utils/date";
import { getDriveLink, getOneLink, getProLink } from "@/utils/link-carrefour";

export default {
  name: "PopinComptePro",
  components: { Popin, Icon, Button, LinkTo },
  props: {
    noService: {
      type: Boolean,
      required: false,
      default: false
    },
    magasin: {
      type: Object,
      required: true
    },
    isOneLink: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["changeMagasin"],
  methods: {
    changeMagasin() {
      this.$emit("changeMagasin");
      this.$refs.popin.hide();
    },
    show() {
      this.$refs.popin.show();
    },
    hide() {
      this.$refs.popin.hide();
    }
  },
  computed: {
    datePremierCreneau() {
      return dateUtils.formatDayMonth(
        this.magasin.attributes.date_premier_creneau_drive_carrefour
      );
    }
  }
};
</script>

<template>
  <Popin
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    ref="popin"
    aria-label="Cora PRO"
    size="md"
    class="u-text-center"
  >
    <p class="c-popin-compte-pro__title u-font-28 u-font-500 u-pr-sm u-pl-sm">
      Services PRO
      <Icon
        name="alert-circle"
        variant="primary"
        size="md"
        class="c-popin-compte-pro__title-icon"
      />
    </p>
    <h1
      class="u-font-secondary u-color-primary u-font-24 u-font-700 u-mt-md"
      :class="!noService && 'u-mb-md'"
    >
      <template v-if="noService">
        Ce magasin ne propose plus le service Pro sur cora.fr
      </template>
      <template v-else>
        Vous ne pouvez pas commander dans ce magasin avec votre compte pro
      </template>
    </h1>
    <p
      v-if="noService"
      class="u-mt-sm"
    >
      Le service Pro évolue et devient Club Pro. Inscrivez-vous dès à présent sur Carrefour Pro pour pouvoir bénéficier de ce service.
      Faites vos achats sur <LinkTo
        variant="primary"
        :to="getDriveLink(magasin)"
        target="_blank"
      >Carrefour.fr</LinkTo> à partir du {{ datePremierCreneau }} ou en attendant rendez vous en magasin.
    </p>
    <p v-else>
      Ce magasin ne fait pas partie de votre convention client en compte. <br>
      Merci de sélectionner un magasin dans lequel vos achats sont autorisés.
    </p>
    <Button
      v-if="noService"
      :to="getProLink()"
      target="_blank"
      variant="primary"
      radius="full"
      size="md"
      class="u-mt-lg"
    >
      Cliquez ici
    </Button>
    <Button
      v-else
      variant="primary"
      radius="full"
      size="md"
      class="u-mt-lg"
      @click="changeMagasin()"
    >
      Je change de magasin
    </Button>
  </Popin>
</template>

<style lang="scss" scoped>
.c-popin-compte-pro__title {
  position: relative;
  display: inline-block;
}
.c-popin-compte-pro__title-icon {
  position: absolute;
  bottom: -12px;
  right: 0px;
}
</style>
